/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Karriere',
    titleMeta: 'Karriere — Ledige stillinger | CamDiab',
    descriptionMeta: 'Utforsk karrieremuligheter i CamDiab. Bli med i teamet som forbedrer livet med diabetes.',
    keywords: 'CamDiab karriere, jobb, ledige stillinger, diabetes',
    localeMeta: 'nb_no',

    bannerTitle: 'Ledige stillinger',
    bannerSubtitle: 'Vil du bli med i teamet vårt?',
    heroNote: 'Alle stillingsannonser publiseres på engelsk.',

    introBody:
        'Leter du etter en ny utfordring og ønsker å bidra til meningsfull endring? Vi vil gjerne høre fra deg. Vi investerer i våre folk — hjertet i CamDiab. Medarbeidergoder er lagt for å få det beste ut av alle, blant annet:',

    benefitsTitle: '',
    benefits: [
        'Sjenerøs arbeidsgiverpensjon',
        'Privat helseforsikring',
        'Livsforsikring',
        'Årlig diskresjonær bonus',
        '29 feriedager pluss 8 helligdager',
        'Mulighet til å jobbe med banebrytende teknologi som kan forandre diabetesomsorg og forbedre pasientutfall',
        'Samarbeidsorientert og dynamisk arbeidsmiljø',
        'Konkurransekraftig lønn og ytelser, inkludert faglig utvikling og karrieremuligheter',
    ],

    outroHtml:
        'Brenner du for reell påvirkning i praksis? Vi vil gjerne høre fra deg:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Ingen ledige stillinger',
    emptyVacancyBody:
        'Vi ansetter kanskje ikke akkurat nå, men CamDiab vokser, og vi vil gjerne høre fra folk som brenner for å gjøre livet med diabetes bedre. Kom tilbake senere.',

    applyLabel: 'Søk nå',
};
